import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from './store/index'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "welcome",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        // Inicio
        {
          name: "Inicio",
          path: "welcome",
          component: () => import("@/components/Monitor/Monitores"),
        },  
        {
          name: "Users",
          path: "users/subscribers",
          component: () => import("@/components/Users/Usuario"),
        },
        {
          name: "Users",
          path: "users/code",
          component: () => import("@/components/Users/Code"),
        },
        {
          name: "Resources",
          path: "resources/questions/:idbook",
          component: () => import("@/components/Resources/Nuevo"),
        }, 
        {
          name: "Resources",
          path: "resources/banks",
          component: () => import("@/components/Resources/Playbooks"),
        }, 
        {
          name: "Resources",
          path: "resources/activity_banks",
          component: () => import("@/components/Resources/Playbooks2"),
        }, 
        {
          name: "Resources",
          path: "resources/activities/:idlibro",
          component: () => import("@/components/Resources/Activities"),
        }, 
        {
          name: "Meeting",
          path: "meeting/one",
          component: () => import("@/components/Meeting/One"),
        }, 
        {
          name: "Meeting",
          path: "meeting/one/:idmeet",
          component: () => import("@/components/Meeting/OneId"),
        },
        {
          name: "Meeting",
          path: "meeting/ones/:idmeet",
          component: () => import("@/components/Meeting/OneId2"),
        },  
        {
          name: "Meeting",
          path: "meeting/team",
          component: () => import("@/components/Meeting/Team"),
        }, 
        {
          name: "Meeting",
          path: "meeting/team/:idmeet",
          component: () => import("@/components/Meeting/TeamId"),
        },
        {
          name: "Meeting",
          path: "meeting/all",
          component: () => import("@/components/Meeting/All"),
        },
        {
          name: "Meeting",
          path: "meeting/conversations",
          component: () => import("@/components/Conversation/ConversationGuides"),
        },
        {
          name: "Meeting",
          path: "meeting/conversation/:idtemplate",
          component: () => import("@/components/Conversation/ConversationBuilder"),
        },
        {
          name: "Meeting",
          path: "meeting/conversation/:idtemplate/:idconv",
          component: () => import("@/components/Conversation/ConversationBuilder"),
        },
        {
          name: "Resources",
          path: "resources/say_cards",
          component: () => import("@/components/Resources/SayCards"),
        },
        {
          name: "Team",
          path: "team",
          component: () => import("@/components/Team/Perfil"),
        },
        {
          name: "Tutorials",
          path: "tutorials/admin",
          component: () => import("@/components/Tutorial/TutorialAdmin"),
          meta: { requiresAdminAuth: true }
        },
        {
          name: "Shopify",
          path: "shopify/products",
          component: () => import("@/components/Shopify/ShopifyProducts"),
          meta: { requiresAdminAuth: true }
        },
      ],
      meta: {
        requiresAuth: true
      }
    }, 
    {
      path: "/login",
      name:"login",
      component: () => import("@/layouts/full-layout/Login")
    },
    {
      path: "*",
      component: () => import("@/layouts/full-layout/NotFound"),
      meta: {
            requiresAuth: false
          }
    }
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  // if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  // }

  store.commit(
    "setRouterHistory",
    from
  );

if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    if (store.getters.getInfoUser && store.getters.getInfoUser.rol == 1) {
      next();
      return;
    }
    next('/');
    return;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.commit(
      "setRouteData",
      {requireAuth: true}
    );
    if (store.getters.getLoginStatus) {
      next();
      return
    }
    next('/login')
  } else {
    store.commit(
      "setRouteData",
      {requireAuth: false}
    );
    next()
  }

  // next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
